import { Injectable } from '@angular/core';

import {
    GeolocationClientConfig,
    GeolocationConfigurationModel,
    InstallerSettingsModel,
    OobeeIntimationModel,
} from '@frontend/geo-coordinator/client-models';
import { ClientConfigProductName, LazyClientConfig, LazyClientConfigBase, LazyClientConfigService } from '@frontend/vanilla/core';

@LazyClientConfig({ key: 'csGeolocationConfig', product: ClientConfigProductName.CASINO })
@Injectable({
    providedIn: 'root',
    deps: [LazyClientConfigService],
    useFactory: casinoGeolocationClientConfigFactory,
})
export class CasinoGeolocationClientConfig extends LazyClientConfigBase implements GeolocationClientConfig {
    isEnabled = false;
    coordinatorSettings?: GeolocationConfigurationModel;
    installerSettings?: InstallerSettingsModel;
    oobeeIntimation?: OobeeIntimationModel;
    desktopLocationValidation = false;
    synchronizationEvent = '';
    synchronizeCoordination = false;
    assetsPath: string[] = [];
    gdsUrl = '';
    initialRetryInterval = -1;
    isRetryButtonEnabled = false;
    retryInterval = -1;
    shouldCheckNativeGeoLocation = false;
    loadAssetsOnServer = false;
    enableRetryCountToCallNative = false;
    gdsFailureCount = -1;
    enableNDBS = false;
}

export function casinoGeolocationClientConfigFactory(service: LazyClientConfigService) {
    return service.get(CasinoGeolocationClientConfig);
}
